module.exports = __webpack_public_path__ + "img/snapping-fingers-drawing.ad658811.png";